import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const Heading = ({
    key,
    img,
    borderColor,
    h3Color,
    imgAlt,
    imgTitle,
    h1,
    h2,
    h3,
    h4,
    h4Src,
    p,
    pSrc,
}) => {
    return (
        // prettier-ignore
        <>
        <ScrollAnimation animateIn="fadeInUp" >
            <img src={img} alt={imgAlt} title={imgTitle} className="card" style={{borderColor: borderColor}}/></ScrollAnimation>

            <ScrollAnimation animateIn="fadeInUp">
                <div className="card card-content" style={{borderColor: borderColor}}>
                    <h1>{h1}</h1>
                    <h2>{h2}</h2>
                    <h3 style={{color: h3Color}}>{h3}</h3>
                    <h4>{h4}<sup><a href={h4Src ? h4Src[0]:null} title={h4Src? h4Src[1]: null}>1</a></sup></h4>

                    <p>{p}<sup><a href={pSrc ? pSrc[0] : null} title={pSrc ? pSrc[1]: null}>1</a></sup></p>
                </div>
            </ScrollAnimation>
        </>
    );
};

export default Heading;
